module.exports = __webpack_public_path__ + "static/media/Category-Universities.416ffe48.jpg";